import { InternalPlanPurchaseProviderContext } from '../PlanPurchaseProvider/context/InternalPlanPurchaseProviderContext'
import { PlanPurchaseProviderContextProps } from './PlanPurchaseProviderContextProps'
import { useContext, useMemo } from 'react'

export function usePlanPurchaseProviderContext(): PlanPurchaseProviderContextProps {
  const context = useContext(InternalPlanPurchaseProviderContext)
  if (!context) {
    throw new Error('usePlanPurchaseProviderContext must be used within a PlanPurchaseProvider')
  }
  const { isLoaded, loadingErrorType, selectedPlan } = context.context
  return useMemo(() => {
    return {
      isLoaded,
      loadingErrorType,
      selectedPlan
    }
  }, [isLoaded, loadingErrorType, selectedPlan])
}
